import { NavItem } from '../../../navigation/comp-layout-sidebar-nav';

/** The Mystery Slabs nav item, whose submenu is the user's mystery slab teams. */
export const MYSTERY_NAV_ID = 'mystery-orders';

export type MysteryTeamNavOption = {
    /** The selection the entry picks: a team id, or "all" for an admin's All teams. */
    value: string;
    label: string;
};

/**
 * The nav with the user's mystery slab teams as the Mystery Slabs submenu, drawn like any other
 * submenu (the Catalog Duplicator and its pages). Each entry picks a team rather than a page —
 * `mysteryTeam` is the selection — and leads to the Mystery Slabs page. Without teams the item
 * stays a plain link. Mystery Slabs sits inside the Orders group, so the search goes down the tree.
 */
export const withMysteryTeamItems = (items: NavItem[], options: MysteryTeamNavOption[]): NavItem[] =>
    options.length === 0
        ? items
        : items.map(item => {
            if (item.id === MYSTERY_NAV_ID) {
                return {
                    ...item,
                    children: options.map(option => ({
                        id: `${MYSTERY_NAV_ID}-team-${option.value}`,
                        label: option.label,
                        path: item.path,
                        mysteryTeam: option.value,
                    })),
                };
            }
            return item.children ? { ...item, children: withMysteryTeamItems(item.children, options) } : item;
        });
